import { api } from "../../api";

export default async function createBillingPortal(): Promise<string> {
  try {
    const { data } = await api.get("/billing/portal");

    if (data?.url) {
      return data.url;
    }

    return "";
  } catch (err) {
    console.log(err);
    throw err;
  }
}
